import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import './Input.scss';
import { isTouchDevice, Icon, useControllableProp } from '../../index';
import { InputClearBtn } from './InputClearBtn';
import { FormItemContext } from '../form/FormItem';
export const Input = forwardRef(({ type = 'text', value, defaultValue, name, placeholder, min, max, step, icon, hasClearBtn, clearBtnTooltip, autoComplete, autoFocus, isDisabled, isReadOnly, isActive, isHovered, isInvalid, isRequired, testId, children, onChange, onClick, onFocus, onBlur, onKeyDown, onKeyUp, }, ref) => {
    const formItemContext = useContext(FormItemContext);
    const inputRef = useRef(null);
    const [currentValue, setCurrentValue] = useControllableProp({
        value: value,
        defaultValue: defaultValue || '',
    });
    const handleChange = (e) => {
        const newValue = e.target.value;
        setCurrentValue?.(newValue);
        onChange?.(e, {
            name,
            value: newValue,
        });
    };
    const handleClick = (e) => {
        onClick?.(e, { name });
    };
    const handleFocus = (e) => {
        onFocus?.(e, { name });
    };
    const handleBlur = (e) => {
        onBlur?.(e, { name });
    };
    const handleKeyDown = (e) => {
        onKeyDown?.(e, { name });
    };
    const handleKeyUp = (e) => {
        onKeyUp?.(e, { name });
    };
    const handleClearBtnClick = (e) => {
        const newValue = '';
        setCurrentValue?.(newValue);
        onChange?.(e, {
            name,
            value: newValue,
        });
    };
    useImperativeHandle(ref, () => ({
        focus: () => {
            if (!isTouchDevice()) {
                inputRef.current?.focus();
            }
        },
        select: () => {
            inputRef.current?.select();
        },
    }));
    return (_jsxs("div", { className: 'sg-input', "data-icon-btn-hover": true, children: [icon && (_jsx("span", { className: 'sg-input--icon', children: _jsx(Icon, { element: icon }) })), _jsx("input", { id: formItemContext.id, className: 'sg-input--element', ref: inputRef, type: type, min: min, max: max, step: step, placeholder: placeholder || ' ', name: name, value: currentValue, disabled: isDisabled, required: isRequired, autoComplete: autoComplete, autoFocus: autoFocus && !isTouchDevice(), readOnly: isReadOnly, onClick: onClick && handleClick, onChange: handleChange, onFocus: onFocus && handleFocus, onBlur: onBlur && handleBlur, onKeyDown: onKeyDown && handleKeyDown, onKeyUp: onKeyUp && handleKeyUp, "aria-describedby": formItemContext.descriptionId, "aria-invalid": isInvalid, "data-active": isActive, "data-hovered": isHovered, "data-test-id": testId }), hasClearBtn !== false && !isDisabled && !isReadOnly && (_jsx(InputClearBtn, { tooltip: clearBtnTooltip, onClick: handleClearBtnClick, testId: testId ? `${testId}-clearBtn` : undefined })), children] }));
});
//# sourceMappingURL=Input.js.map